<template>
  <div class="otherFees">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>公司类型：</p>
        <el-select v-model="voyageIpt" filterable size="mini" style="width:150px"
                   placeholder="请选择公司类型">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label"
                     :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>公司名称：</p>
        <el-input v-model="numberIpt" size="mini" style="width:150px" placeholder="请输入公司名称"/>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="deductionNum" label="抵扣编号" align="center" show-overflow-tooltip/>
          <el-table-column prop="companyType" label="公司类型" align="center">
            <template slot-scope="scope">{{ scope.row.companyType|getCompanyType }}</template>
          </el-table-column>
          <el-table-column prop="companyName" label="公司名称" align="center" width="150"
                           show-overflow-tooltip/>
          <el-table-column prop="discountAmount" label="抵扣金额" align="center"/>
          <el-table-column prop="remainingDiscountAmount" label="剩余抵扣金额" align="center"/>
          <el-table-column prop="instruction" label="说明" align="center" max-width="150"
                           show-overflow-tooltip/>
          <el-table-column prop="createdTime" label="添加时间" align="center" width="150"/>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="searchBtn" type="primary"
                         @click="detailClick(scope.row.id)">详情
              </el-button>
              <el-button v-if="scope.row.auditType==1&&scope.row.choise==1" size="mini"
                         type="primary" @click="enableClick(scope.row.id)">同意
              </el-button>
              <el-button v-if="scope.row.auditType==1&&scope.row.choise==1" size="mini"
                         type="danger" @click="disableClick(scope.row.id)">拒绝
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailShowFlag" width='700px' center top="10vh"
               :close-on-click-modal="false">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">抵扣编号：</span>
              <span>{{ detailData.deductionNum }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">公司类型：</span>
                <span>{{ detailData.companyType|getCompanyType }}</span>
              </div>
              <div>
                <span class="span1">公司名称：</span>
                <span>{{ detailData.companyName }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">抵扣金额：</span>
                <span>{{ detailData.discountAmount }}</span>
              </div>
              <div>
                <span class="span1">剩余抵扣金额：</span>
                <span>{{ detailData.remainingDiscountAmount }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">说明：</span>
              <span>{{ detailData.instruction }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">添加时间：</span>
              <span>{{ detailData.createdTime }}</span>
            </div>
          </div>
          <div class="baseInfo">
            <div class="baseInfoTitle">
              <div class="line"/>
              <span>审核信息</span>
            </div>
            <steps :step-data="stepData" :step-state="stepState"/>
          </div>
          <div class="baseInfo" v-if="detailData.auditType==1&&detailData.choise==1">
            <div class="baseInfoTitle">
              <div class="line"/>
              <span>操作</span>
            </div>
            <div class="baseInfoContentItem">
              <div style="display: flex;margin:10px 20px 0 15px;">
                <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>
                <el-input
                  type="textarea"
                  :style="'width:100%'"
                  v-model="remark"
                  placeholder="请填写同意/拒绝原因"
                  autocomplete="off"
                  size="small"
                />
              </div>
            </div>
          </div>
          <div v-if="detailData.auditType==1&&detailData.choise==1"
               style="display: flex;align-items: center;justify-content: center">
            <el-button size="medium" type="primary" @click="agreeClick">同意</el-button>
            <el-button size="medium" type="danger" @click="refusedClick">拒绝</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import steps from '@/components/steps';
import { deductDetail, deductReviewSubmit, deductPageList } from '@/service/audit';

export default {
  components: { steps },
  data() {
    return {
      companyData: {},
      voyageIpt: '',
      numberIpt: '',
      typeOption: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 0,
          label: '委托商',
        },
        {
          value: 1,
          label: '公路供应商',
        },
        {
          value: 2,
          label: '水路供应商',
        },
        {
          value: 3,
          label: '港口及其他',
        },
      ],
      page: 1,
      size: 10,
      total: 0,
      tableLoad: false,
      TableDatas: [],
      detailShowFlag: false,
      detailData: {},
      stepData: [],
      remark: '',
    };
  },
  created() {
    this.searchBtn();
  },
  filters: {
    getCompanyType(val) {
      switch (val) {
        case 0:
          return '委托商';
        case 1:
          return '公路供应商';
        case 2:
          return '水路供应商';
        case 3:
          return '港口及其他';
      }
    },
  },
  computed: {
    stepState() {
      return function (state) {
        switch (state) {
          case '':
            return 'wait';
          case 'success':
            return 'success';
          case 'failure':
            return 'error';
        }
      };
    },
    getStyle() {
      return (val) => {
        switch (val) {
          case 2:
            return 'color: rgba(51, 136, 255, 1);';
          case 1:
            return 'color: rgba(249, 166, 6, 1)';
          case 3:
            return 'color:#F56C6C;';
          case 4:
            return 'color:#F56C6C;';
        }
      };
    },
    getState() {
      return function (state) {
        switch (state) {
          case 1:
            return '待审核';
          case 2:
            return '已通过';
          case 3:
            return '已拒绝';
          case 4:
            return '已取消';
        }
      };
    },
    getDeliveryAddressType() {
      return function (type) {
        switch (type) {
          case 0:
            return '委托商';
          case 1:
            return '公路供应商';
          case 2:
            return '水路供应商';
          case 3:
            return '港口及其他';
        }
      };
    },
  },
  methods: {
    contractSizeChange(sizes) {
      this.size = sizes;
      this.searchBtn();
    },
    contractCurrentChange(page) {
      this.page = page;
      this.searchBtn();
    },
    // 查询
    searchBtn() {
      this.page = 1;
      const data = {
        page: this.page,
        row: this.size,
        companyType: this.voyageIpt, // 公司类型
        companyName: this.numberIpt, // 公司名称
      };
      this._deductPageList(data);
    },
    // 分页查询
    async _deductPageList(data) {
      this.tableLoad = true;
      const res = await deductPageList(data);
      this.tableLoad = false;
      if (res.status == 0) {
        this.total = res.data.total;
        this.TableDatas = res.data.records;
      } else {
        this.$message.error(res.message);
      }
    },
    // 重置
    resetBtn() {
      this.voyageIpt = '';
      this.numberIpt = '';
    },
    // 详情
    async detailClick(id) {
      this.detailShowFlag = true;
      const res = await deductDetail(id);
      if (res.status !== 0) return this.$message.error(res.message);
      this.detailData = res.data;
      this.stepData = [];
      if (res.data.auditRecordList.length > 0) {
        res.data.auditRecordList.forEach((item) => {
          let status = '';
          let temp = {};
          let
            text = '取消审核';
          if (item.status == 1) {
            text = '发起';
          }
          if (item.status == 0) {
            text = '重新发起';
          }
          if (item.status == 3) {
            status = 'failure', text = '拒绝';
            temp = {
              title: `${item.deptName} ${item.auditorName} ${text}`,
              time: item.createTime,
              state: status,
              remark: item.opinion,
            };
          } else if (item.status == 2) {
            status = 'success', text = '同意';
            temp = {
              title: `${item.deptName} ${item.auditorName} ${text}`,
              time: item.createTime,
              state: status,
              remark: item.opinion,
            };
          } else {
            temp = {
              title: `${item.auditorName} ${text}`,
              time: item.createTime,
              state: status,
              remark: '',
            };
          }
          this.stepData.push(temp);
        });
      }
    },
    // 同意
    enableClick(id) {
      this.$prompt('确认同意当前抵扣开票费用申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator(value) {
          if (!value) {
            return false;
          }
        },
        inputErrorMessage: '同意原因不能为空',
        type: 'warning',
      })
        .then(async ({ value }) => {
          const res = await deductReviewSubmit({
            id,
            auditOpinion: value,
            // t同意
            reviewResult: 'AGREE',
          });
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.detailShowFlag = false;
          this.searchBtn();
        })
        .catch(() => {
        });
    },
    // 拒绝
    disableClick(id) {
      this.$prompt('确认拒绝当前抵扣开票费用申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator(value) {
          if (!value) {
            return false;
          }
        },
        inputErrorMessage: '拒绝原因不能为空',
        type: 'warning',
      })
        .then(async ({ value }) => {
          const res = await deductReviewSubmit({
            id,
            auditOpinion: value,
            // 拒绝
            reviewResult: 'REFUSE',
          });
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.detailShowFlag = false;
          this.searchBtn();
        })
        .catch(() => {
        });
    },
    // 详情同意
    async agreeClick() {
      this.remark = this.remark.trim();
      if (!this.remark) return this.$message.warning('请填写同意理由！');
      const res = await deductReviewSubmit({
        id: this.detailData.id,
        auditOpinion: this.remark,
        // 同意
        reviewResult: 'AGREE',
      });
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.detailShowFlag = false;
      this.remark = '';
      this.searchBtn();
    },
    // 详情拒绝
    async refusedClick() {
      this.remark = this.remark.trim();
      if (!this.remark) return this.$message.warning('请填写拒绝理由！');
      const res = await deductReviewSubmit({
        id: this.detailData.id,
        auditOpinion: this.remark,
        // 拒绝
        reviewResult: 'REFUSE',
      });
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.detailShowFlag = false;
      this.remark = '';
      this.searchBtn();
    },
  },
};
</script>

<style lang="scss" scoped>
.otherFees {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 10px;
      margin-bottom: 25px;
      width: 100%;

      &Nav {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        span {
          color: rgba(51, 136, 255, 1);
          text-decoration: underline;
          margin-right: 10px;

          &:hover {
            cursor: pointer;
          }
        }
      }

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  ::v-deep {
    .el-table th > .cell {
      font-weight: 700 !important;
    }
  }

  .detail {
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height: 70vh;
    overflow: auto;

    .baseInfo {
      display: flex;
      flex-direction: column;

      .attachment {
        display: flex;
        flex-direction: column;
        padding-top: 10px;

        &Item {
          width: 80%;
          margin-bottom: 10px;
          margin-left: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            color: #969696;
            font-size: 14px;
          }
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;

        &Item {
          margin-bottom: 20px;

          .span1 {
            font-weight: 700;
          }

          span {
            font-size: 14px;
          }

          .specialOne {
            width: 50%;
          }
        }

        .specialItem {
          display: flex;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      ::v-deep {
        .el-table td, .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
}

::v-deep {
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .el-dialog__headerbtn {
    top: 9px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
